module.exports = __webpack_public_path__ + "static/macbook-4a0e751ee6248c8da8861146f42b84c1.jpg";